/**
 * Componente de skeleton para el módulo de Tracking
 * Skeleton component for Tracking module
 */
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const TrackingSkeleton = () => {
  return (
    <div className="px-6 py-4 space-y-6">
      {/* Barra de filtros Skeleton */}
      <div className="mb-4 flex flex-wrap items-center gap-3 p-4 bg-card-bg border border-card-border rounded-lg">
        <Skeleton className="h-10 w-[180px] rounded-md bg-hover-press" />
        <Skeleton className="h-10 w-[150px] rounded-md bg-hover-press" />
        <Skeleton className="h-10 w-[100px] rounded-md bg-hover-press ml-auto" />
        <Skeleton className="h-10 w-[100px] rounded-md bg-hover-press" />
      </div>

      {/* Tabs Skeleton */}
      <SectionBox className="bg-card-bg">
        <div className="flex gap-2 mb-6 border-b border-card-border">
          <Skeleton className="h-10 w-24 rounded-md bg-hover-press" />
          <Skeleton className="h-10 w-24 rounded-md bg-hover-press" />
          <Skeleton className="h-10 w-24 rounded-md bg-hover-press" />
        </div>
        <Skeleton className="h-[256px] w-full rounded-md bg-hover-press" />
      </SectionBox>

      {/* Sección de estado de couriers */}
      <SectionBox className="bg-card-bg">
        <Skeleton className="h-6 w-48 rounded-full bg-hover-press mb-4" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3].map((index) => (
            <div key={index} className="border rounded-lg p-4 bg-card-bg">
              <div className="flex items-start justify-between mb-3">
                <Skeleton className="h-5 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-6 w-16 rounded-md bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
              </div>
            </div>
          ))}
        </div>
      </SectionBox>

      {/* Tabla Skeleton */}
      <SectionBox className="bg-card-bg">
        <Skeleton className="h-6 w-48 rounded-full bg-hover-press mb-4" />
        <div className="space-y-3">
          <div className="grid grid-cols-5 gap-4 pb-3 border-b border-card-border">
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
          </div>
          {[1, 2, 3, 4, 5].map((index) => (
            <div key={index} className="grid grid-cols-5 gap-4 py-3 border-b border-card-border last:border-b-0">
              <Skeleton className="h-5 w-16 rounded-full bg-hover-press" />
              <Skeleton className="h-5 w-32 rounded-full bg-hover-press" />
              <Skeleton className="h-5 w-20 rounded-full bg-hover-press" />
              <Skeleton className="h-5 w-32 rounded-full bg-hover-press" />
              <Skeleton className="h-5 w-20 rounded-full bg-hover-press" />
            </div>
          ))}
        </div>
      </SectionBox>
    </div>
  );
};
